import React, { useEffect, useState } from 'react'

import useFirebase from 'hooks/firebase'

import { useUtils } from 'config/utils'

import {
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material'

import PersonAddIcon from '@mui/icons-material/PersonAdd'

import LoadingButton from '@mui/lab/LoadingButton'

const CreateStudent = (props) => {
  const { director } = props
  
  const { validateEmail } = useUtils()

  const { functions } = useFirebase()
  const { createUser } = functions

  const [loading, setLoading] = useState(false)

  const [stages, setStages] = useState([])

  const [level, setLevel] = useState('')
  const handleLevelChanged = (event) => {
    setLevel(event.target.value)
  }

  const [firstName, setFirstName] = useState('')
  const handleFirstNameChanged = (event) => {
    setFirstName(event.target.value)
  }

  const [fathersLastName, setFathersLastName] = useState('')
  const handleFathersLastNameChanged = (event) => {
    setFathersLastName(event.target.value)
  }

  const [mothersLastName, setMothersLastName] = useState('')
  const handleMothersLastNameChanged = (event) => {
    setMothersLastName(event.target.value)
  }

  const [email, setEmail] = useState('')
  const handleEmailChanged = (event) => {
    setEmail(event.target.value)
  }

  const fixedStages = ['Kinder', 'Primaria', 'Secundaria', 'Preparatoria']
  useEffect(() => {
    // if (school === undefined) return
    // const sortedStages = school.stages !== undefined ? school.stages : []
    // sortedStages.sort((a, b) => fixedStages.indexOf(a) - fixedStages.indexOf(b))
    setStages(fixedStages)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const [grades] = useState(['1°', '2°', '3°', '4°', '5°', '6°'])
  const [grade, setGrade] = useState('')
  const handleGradeChanged = (event) => {
    setGrade(event.target.value)
  }

  const [groups] = useState(['A', 'B', 'C', 'D', 'E', 'F'])
  const [group, setGroup] = useState('')
  const handleGroupChanged = (event) => {
    setGroup(event.target.value)
  }

  const onCreate = async () => {
    setLoading(true)
    const data = {
      'role': 'student',
      'schoolId': director.schoolId,
      'user': {
        'firstName': firstName,
        'fathersLastName': fathersLastName,
        'mothersLastName': mothersLastName,
        'name': `${firstName} ${fathersLastName}`,
        'email': email,
        'level': level,
        'grade': grade,
        'group': group
      },
    }
    await createUser(data)
    setLoading(false)
    clean()
  }

  const clean = () => {
    setFirstName('')
    setFathersLastName('')
    setMothersLastName('')
    setEmail('')
    setLevel('')
    setGrade('')
    setGroup('')
  }

  return (
    <Card sx={{ borderColor: '#655dc633', borderRadius: 2, p: 2 }}>
      <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography color='primary' variant='body1'>
              <b style={{ fontWeight: 900 }}>NUEVO ALUMNO</b>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={firstName}
              onChange={handleFirstNameChanged}
              placeholder='Ingresa el nombre'
              label='Nombre'
              InputLabelProps={{ shrink: true }}
              fullWidth
              sx={{ flexGrow: 1 }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={fathersLastName}
              onChange={handleFathersLastNameChanged}
              placeholder='Ingresa el apellido paterno'
              label='Apellido paterno'
              InputLabelProps={{ shrink: true }}
              fullWidth
              sx={{ flexGrow: 1 }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={mothersLastName}
              onChange={handleMothersLastNameChanged}
              placeholder='Ingresa el apellido materno'
              label='Apellido materno'
              InputLabelProps={{ shrink: true }}
              fullWidth
              sx={{ flexGrow: 1 }}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={email}
              onChange={handleEmailChanged}
              placeholder='Ingresa el email'
              label='Email'
              InputLabelProps={{ shrink: true }}
              fullWidth
              sx={{ flexGrow: 1 }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth variant='outlined'>
              <InputLabel shrink id='select-outlined-stage'>Nivel</InputLabel>
              <Select
                displayEmpty
                labelId='select-outlined-stage'
                id='select-outlined-stage'
                onChange={handleLevelChanged}
                value={level}
                label='Nivel'
                notched
              >
                <MenuItem disabled value=''>
                  <em>Seleccionar</em>
                </MenuItem>
                { 
                  stages.map((stage, index) =>
                    <MenuItem key={`stage_${index}`} value={stage}>
                      {stage}
                    </MenuItem>
                  )
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth variant='outlined'>
              <InputLabel shrink id='select-outlined-grade'>Grado</InputLabel>
              <Select
                displayEmpty
                labelId='select-outlined-grade'
                id='select-outlined-grade'
                onChange={handleGradeChanged}
                value={grade}
                label='Grado'
                notched
              >
                <MenuItem disabled value=''>
                  <em>Seleccionar</em>
                </MenuItem>
                { 
                  grades.map((grade, index) =>
                    <MenuItem key={`grade_${index}`} value={grade}>
                      {grade}
                    </MenuItem>
                  )
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <FormControl fullWidth variant='outlined'>
              <InputLabel shrink id='select-outlined-group'>Grupo</InputLabel>
              <Select
                displayEmpty
                labelId='select-outlined-group'
                id='select-outlined-group'
                onChange={handleGroupChanged}
                value={group}
                label='Grupo'
                notched
              >
                <MenuItem disabled value=''>
                  <em>Seleccionar</em>
                </MenuItem>
                { 
                  groups.map((group, index) =>
                    <MenuItem key={`grade_${index}`} value={group}>
                      {group}
                    </MenuItem>
                  )
                }
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} align='right'>
            <LoadingButton disabled={firstName === '' || fathersLastName === '' || mothersLastName === '' || !validateEmail(email) || level === '' || grade === '' || group === ''} disableElevation loading={loading} loadingPosition='start' startIcon={<PersonAddIcon />} variant='contained' onClick={onCreate}>
              <b style={{ fontWeight: 900 }}>{ loading ? 'CREANDO' : 'CREAR' }</b>
            </LoadingButton>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default CreateStudent